import { makeStyles } from '@fluentui/react-components';

export const useFlightNumberDialogStyles = makeStyles({
    flightNumberDialog: {
        maxWidth: '400px',
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    inputWrapper: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '250px',
    },
    errorMessage: {
        color: 'var(--colorPaletteRedForeground1)',
        fontSize: '12px',
        marginTop: '4px',
    },
});